
import Vue from 'vue';
import _ from 'lodash';

interface RmAlias {
  _id: number;
  alias: string;
  productLine: string;
}

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    group: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    rowDisabled: { type: Boolean, default: false }
  },
  data(): { 
    rmFormValues: (number | undefined)[]
  } {
    return {
      rmFormValues: [undefined]
    }
  },
  computed: {
    productDetails: function(): any {
      return this.getVariable(this.input.productDataVariable);
    },
    productLine: function(): string {
      return _.get(this.productDetails, 'productLine', '');
    },
    items: function(): RmAlias[] {
      return this.getVariable(this.input.items) || [];
    },
    rmAlias: function(): number[] {
      return this.getVariable(this.input.variable);
    }
  },
  mounted() {
    const { prefix, key } = this.parent._getPrefixAndKey(this.input.variable);
    const variableExists = !!this.parent._getVariable(prefix);
    if(!variableExists || !this.rmAlias) {
      this.$set(this.parent._getVariable(prefix), key, []);
    }
    if(this.rmAlias.length) {
      this.rmFormValues = this.rmAlias;
    }
  },
  methods: {
    onValueChange(value: number, index: number) {
      let currentRmAliasArray = [ ...this.rmAlias ];
      currentRmAliasArray[index] = value;
      const { prefix, key } = this.parent._getPrefixAndKey(this.input.variable);
      this.$set(this.parent._getVariable(prefix), key, currentRmAliasArray);

    },
    filterItems(rmFamily: string[]): RmAlias[] {
      return this.items.filter((item: RmAlias) => rmFamily.includes(item.productLine));
    },
    filterItemsForCommonProductLines(materialType: 'base' | 'top'): RmAlias[] {
      if(this.productLine == 'PSL') {
        return this.items.filter((item: RmAlias) => materialType == 'base' ? item.productLine == 'PSL' : item.productLine == 'Film');
      } else if(this.productLine == 'Cake Board') {
        return this.items.filter((item: RmAlias) => materialType == 'base' ? item.productLine == 'Board' : item.productLine == 'Film');
      } else if(this.productLine == 'Ribbon') {
        return this.items.filter((item: RmAlias) => item.productLine == 'Ribbon');
      } else {
        return this.items.filter((item: RmAlias) => item.productLine == 'Paper');
      }
    }
  }
});
